import Cookies from 'js-cookie'
import i18n from '@/i18n'
import { getSumFloatNum } from '@/utils/tool'

const user = {
  state: {
    deviceInfo: null,
    memberInfo: null,
    token: null,
    favoriteGame: null,
    language: Cookies.get('language') || 'zh',
    supportLanguages: [],
    currentGameCategory: null,
    currentGameProvider: null,
    goldInfo: null,
    mainGold: null,
    bonusGold: null,
    mainPoint: null,
    mainTurnover: null,
    point: null,
    goldTotal: null,
    commissionGold: null,
    vipInfo: null,
    inviteCode: null,
    shareCode: null,
    couponCode: null,
    group: null,
    unreadLetter: false,
    newLetter: false,
    gameBalanceInfo: {}, // 遊戲錢包餘額,
    walletInfo: [], // Add walletInfo to state
    isRegisterActive: false,
    isLoginActive: false,
    isForgetActive: false,
    isCampaignLoginActive: false,
    isCampaignForgetActive: false,
    isCampaignDepositActive: false,
    isLoginToEvent: false,
    isResetPasswordActive: false,
    isCheckoutCounterActive: false,
    isCheckoutCounterBCPayActive: false,
    isValidateFail: false,
    activeFilter: 'others',
    events: [],
    eventV4Ids: null,
    isFromMenu: false,
    isFromChampionship: false,
    isFromChampionshipGame: false,
    isFromPromotion: false,
    isFromKYCVerify: false,
    championEvent: [],
    registerSuccess: false,
    isFromDaily: false,
    dailyItem: [],
    isConfirmPurchase: false,
    isConfirmPurchaseDoubleCheck: false,
    newMember: null,
    sortedEvents: [],
    lotteryId: null,
    wheelOpen: false,
    wheelCountdown: '',
    lastTriggerTime: null,
    isFAQActive: false,
    isProxyRegisterActive: false,
    isConditionActive: false,
    isReviewActive: false,
    newsIndex: null,
    authStatus: 0,
    socialType: localStorage.getItem('social_type') || null, // 'google': 第三方登入 / 'account': 平台帳密登入
    isSetUsernameActive: false, // 第三方登入後需補設定 username 的彈窗
    usernameSetupToken: null, // /user/login code 2201 回傳，補設定 username 時帶回後端
    usernameSetupCredential: null // 2201 當下的 Google credential，next_action=login 時重打 /user/login 用
  },
  mutations: {
    SET_DEVICE_INFO: (state, data) => {
      state.deviceInfo = data
    },
    SET_MEMBER_INFO: (state, data) => {
      state.memberInfo = data
    },
    SET_TOKEN: (state, data) => {
      state.token = data
    },
    SET_LANGUAGE: (state, language) => {
      if (language !== 'undefined') {
        state.language = language
        Cookies.set('language', language)
        i18n.locale = language
      }
    },
    SET_SUPPORT_LANGUAGES: (state, supportLanguages) => {
      state.supportLanguages = supportLanguages
      Cookies.set('supportLanguages', supportLanguages)
    },
    SET_CURRENT_GAME_CATEGORY: (state, category) => {
      state.currentGameCategory = category
    },
    SET_CURRENT_GAME_PROVIDER: (state, type) => {
      state.currentGameProvider = type
    },
    SET_GOLD_INFO: (state, data) => {
      state.goldInfo = data
    },
    SET_VIP_INFO: (state, data) => {
      state.vipInfo = data
    },
    SET_INVITE_CODE: (state, data) => {
      state.inviteCode = data
    },
    SET_SHARE_CODE: (state, data) => {
      state.shareCode = data
    },
    SET_BTAG_CODE: (state, data) => {
      state.btag = data
    },
    SET_COUPON_CODE: (state, data) => {
      state.couponCode = data
    },
    SET_GROUP: (state, data) => {
      state.group = data
    },
    SET_UNREAD_LETTER: (state, data) => {
      state.unreadLetter = data
    },
    SET_GAME_BALANCE_INFO: (state, data) => {
      state.gameBalanceInfo = data
    },
    SET_FAVORITE_GAME: (state, data) => {
      state.favoriteGame = data
    },
    SET_ACTIVE_FILTER(state, filter) {
      state.activeFilter = filter
    },
    SET_WHEEL_OPEN(state, value) {
      state.wheelOpen = value
    },
    SET_WHEEL_TIME(state, value) {
      state.wheelCountdown = value
    },
    SET_LAST_TRIGGER_TIME(state, lastTriggerTime) {
      state.lastTriggerTime = lastTriggerTime
    },
    ADD_LOTTERY_ID(state, id) {
      state.lotteryId = id
    },
    ADD_NEWS_ID(state, id) {
      state.newsId = id
    },
    SET_UNREAD_LETTER_PLUS: (state) => {
      if (!state.unreadLetter) {
        state.unreadLetter = 1
      } else {
        state.unreadLetter += 1
      }
    },
    SET_NEW_LETTER: (state, data) => {
      state.newLetter = data
    },
    SET_MAIN_GOLD: (state, data) => {
      if (!data) {
        state.mainGold = null
      } else {
        const main_gold = String(data.main_gold)

        state.mainGold = getSumFloatNum([main_gold], 4)
      }
    },
    SET_BONUS_GOLD: (state, data) => {
      if (!data) {
        state.bonusGold = null
      } else {
        const bonus_gold = String(data.bonus_gold)

        state.bonusGold = getSumFloatNum([bonus_gold], 4)
      }
    },
    SET_MAIN_POINT: (state, data) => {
      if (!data) {
        state.mainPoint = null
      } else {
        const main_points = String(data.main_points)

        state.mainPoint = getSumFloatNum([main_points], 4)
      }
    },
    SET_MAIN_TURNOVER: (state, data) => {
      if (!data) {
        state.mainTurnover = null
      } else {
        const main_turnover = String(data.main_turnover)

        state.mainTurnover = getSumFloatNum([main_turnover], 4)
      }
    },
    SET_POINTS: (state, data) => {
      if (!data) {
        state.point = null
      } else {
        const mainPoints = parseFloat(data.main_points || 0)
        const bonusPoints = parseFloat(data.bonus_points || 0)
        const total = mainPoints + bonusPoints

        state.point = getSumFloatNum([total.toString()], 3)
      }
    },
    SET_COMMISSION_GOLD: (state, data) => {
      if (!data) {
        state.commissionGold = null
      } else {
        const commission_gold = String(data.commission_gold)

        state.commissionGold = getSumFloatNum([commission_gold], 4)
      }
    },
    SET_GOLD_TOTAL: (state, data) => {
      if (!data) {
        state.goldTotal = null
      } else {
        const commission_gold = String(data.commission_gold)
        const main_gold = String(data.main_gold)

        state.goldTotal = getSumFloatNum([commission_gold, main_gold], 2)
      }
    },
    ADD_EVENTS(state, data) {
      state.events = data
    },
    ADD_V4_ID(state, id) {
      state.eventV4Ids = id
    },
    SET_REGISTER_OPEN(state, value) {
      state.isRegisterActive = value
    },
    SET_LOGIN_OPEN(state, value) {
      state.isLoginActive = value
    },
    SET_WALLET_INFO(state, value) {
      state.walletInfo = value
    },
    SET_FORGET_OPEN(state, value) {
      state.isForgetActive = value
    },
    SET_CAMP_LOGIN_OPEN(state, value) {
      state.isCampaignLoginActive = value
    },
    SET_CAMP_FORGET_OPEN(state, value) {
      state.isCampaignForgetActive = value
    },
    SET_CAMP_DEPOSIT_OPEN(state, value) {
      state.isCampaignDepositActive = value
    },
    SET_FAQ_OPEN(state, value) {
      state.isFAQActive = value
    },
    SET_PROXY_OPEN(state, value) {
      state.isProxyRegisterActive = value
    },
    SET_CONDITION_OPEN(state, value) {
      state.isConditionActive = value
    },
    SET_REVIEW_OPEN(state, value) {
      state.isReviewActive = value
    },
    SET_LOGIN_TO_EVENT(state, value) {
      state.isLoginToEvent = value
    },
    SET_RESET_PASSWORD_OPEN(state, value) {
      state.isResetPasswordActive = value
    },
    SET_CHECKOUT_COUNTER_OPEN(state, value) {
      state.isCheckoutCounterActive = value
    },
    SET_CHECKOUT_COUNTER_BCPAY_OPEN(state, value) {
      state.isCheckoutCounterBCPayActive = value
    },
    SET_VAILTADA_FAIL(state, value) {
      state.isValidateFail = value
    },
    SET_FROM_MENU(state, value) {
      state.isFromMenu = value
    },
    SET_CHAMPIONSHIP(state, value) {
      state.isFromChampionship = value
    },
    SET_CHAMPIONSHIP_GAME(state, value) {
      state.isFromChampionshipGame = value
    },
    SET_PROMOTION(state, value) {
      state.isFromPromotion = value
    },
    SET_KYC_VERIFY(state, value) {
      state.isFromKYCVerify = value
    },
    SET_CHAMPIONSHIP_EVENT(state, value) {
      state.championEvent = value
    },
    SET_REGISTER_SUCCESS(state, value) {
      state.registerSuccess = value
    },
    SET_DAILY(state, value) {
      state.isFromDaily = value
    },
    SET_DAILY_ITEM(state, value) {
      state.dailyItem = value
    },
    SET_CONFIRM_PURCHASE(state, value) {
      state.isConfirmPurchaseDoubleCheck = value
    },
    SET_SHOP_PURCHASE(state, value) {
      state.isConfirmPurchase = value
    },
    SET_NEW_MEMBER(state, value) {
      state.newMember = value
    },
    setSortedEvents(state, events) {
      state.sortedEvents = events
    },
    updateEventSelection(state, selectedEventId) {
      state.sortedEvents.forEach(event => {
        if (event.id === selectedEventId) {
          // Toggle the select state of the clicked event
          console.log('update', event.id, event.select)

          if (!event.select) {
            event.select = true
          }
        } else {
          event.select = false
        }
      })
    },
    SET_CHOOSE_NEWS(state, value) {
      state.newsIndex = value
    },
    SET_GOOGLE_AUTH_STATUS(state, value) {
      state.authStatus = value
    },
    SET_SOCIAL_TYPE(state, value) {
      state.socialType = value
      // 存 localStorage，重整頁面後仍可判斷第三方帳號限制
      if (value) {
        localStorage.setItem('social_type', value)
      } else {
        localStorage.removeItem('social_type')
      }
    },
    SET_SET_USERNAME_OPEN(state, value) {
      state.isSetUsernameActive = value
    },
    SET_USERNAME_SETUP_TOKEN(state, value) {
      state.usernameSetupToken = value
    },
    SET_USERNAME_SETUP_CREDENTIAL(state, value) {
      state.usernameSetupCredential = value
    }
  },
  actions: {
    // 登入
    SetUserData({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_MEMBER_INFO', data.member_info)
        commit('SET_GOLD_INFO', data.gold_info)
        commit('SET_GOLD_TOTAL', data)
        commit('SET_MAIN_GOLD', data)
        commit('SET_BONUS_GOLD', data)
        commit('SET_MAIN_POINT', data.member_info)
        commit('SET_MAIN_TURNOVER', data.member_info)
        commit('SET_COMMISSION_GOLD', data)
        commit('SET_VIP_INFO', data.vip_info)
        commit('SET_FAVORITE_GAME', data.member_info.favorite.game)
        commit('SET_GOOGLE_AUTH_STATUS', data.google_auth_totp_status)

        if (data.social_type !== undefined) {
          commit('SET_SOCIAL_TYPE', data.social_type)
        }

        if (data.device_info !== undefined) {
          commit('SET_DEVICE_INFO', data.device_info)
        }
        if (data.token !== undefined) {
          commit('SET_TOKEN', data.token.token)
        }

        if (data.unread_letter_num === 0) {
          commit('SET_UNREAD_LETTER', false)
        } else {
          commit('SET_UNREAD_LETTER', data.unread_letter_num)
        }

        resolve()
      })
    },
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_DEVICE_INFO', null)
        commit('SET_MEMBER_INFO', null)
        commit('SET_TOKEN', null)
        commit('SET_GOLD_INFO', null)
        commit('SET_GOLD_TOTAL', null)
        commit('SET_MAIN_GOLD', null)
        commit('SET_BONUS_GOLD', null)
        commit('SET_MAIN_POINT', null)
        commit('SET_MAIN_TURNOVER', null)
        commit('SET_COMMISSION_GOLD', null)
        commit('SET_SELECTED_WALLET', null)
        commit('SET_VIP_INFO', '')
        commit('SET_FAVORITE_GAME', null)
        commit('SET_GAME_BALANCE_INFO', [])
        commit('SET_ACTIVE_FILTER', 'others')
        commit('SET_CURRENT_GAME_CATEGORY', null)
        commit('SET_CURRENT_GAME_PROVIDER', null)
        commit('SET_SOCIAL_TYPE', null)
        localStorage.clear()
        resolve()
      })
    },
    initializeSortedEvents({ commit }, events) {
      commit('setSortedEvents', events)
    },
    selectEvent({ commit }, eventId) {
      commit('updateEventSelection', eventId)
    }
  }
}

export default user
